export const CONFIRMED_MENU = "CONFIRMED_MENU";
export const PENDING_MENU = "PENDING_MENU";
export const CANCELLED_MENU = "CANCELLED_MENU";

export const CONFIRMED_LOGO = "check";
export const PENDING_LOGO = "clock";
export const CANCELLED_LOGO = "x";

export const CONFIRMED_COLOR = "green";
export const PENDING_COLOR = "orange";
export const CANCELLED_COLOR = "red";

export const NO_CONFIRMED_RESERVATION_TEXT = "Aucune réservation.";
export const NO_PENDING_RESERVATION_TEXT = "Aucune réservation en attente de confirmation.";
export const NO_CANCELLED_RESERVATION_TEXT = "Aucune réservation annulée.";

export const ADD_RESERVATION_LOGO = "add to calendar";
export const ADD_RESERVATION_COLOR = "blue";

export const RESERVATION_ICON = "calendar";
export const SEATS_ICON = "food";

export const USER_ICON = "user";

export const CLEAR_INPUT_LOGO = "delete";

export const CALENDAR_LOGO = "calendar alternate";
export const CALENDAR_COLOR = "red";

export const HISTORY_LOGO = "history";
export const HISTORY_COLOR = "purple";

export const VIEW_RESERVATION_LOGO = "eye";
export const VIEW_RESERVATION_COLOR = "blue";

export const PREVIOUS_DAY_LOGO = "angle left";
export const NEXT_DAY_LOGO = "angle right";

export const GUEST_CHART_COLORS = [
    "#5e4fa2",
    "#3288bd",
    "#66c2a5",
    "#abdda4",
    "#e6f598",
    "#fee08b",
    "#fdae61",
    "#f46d43",
    "#d53e4f",
    "#9e0142",
];

export const TIMELINE_ITEMS_COLORS = [
    'red', 'blue', 'pink', 'olive', 'orange', 'yellow', 'green', 'teal', 'violet', 'purple', 'brown', 'grey', 'black'
];

export const CHART_COLORS = [
    'cornflowerblue', 'darkgreen', 'blue', 'olive', 'orange', 'yellowgreen', 'green', 'teal', 'violet', 'purple', 'brown', 'grey', 'black'
];

export const FLOORPLAN_ITEMS_COLORS = [
    'cornflowerblue', 'darkgreen', 'blue', 'olive', 'orange', 'yellowgreen', 'green', 'teal', 'violet', 'purple', 'brown', 'grey', 'black'
];

export const TIMELINE_ITEMS_SUFFIXES = [
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
    'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
];

export const CONFIRM_TABLE_DELETE_TEXT = "Voulez-vous vraiment supprimer cette table ? Cette action est " +
    "irréversible et les réservations liées à cette table ne seront plus assignées à une table. De plus, tous les liens de tables dont elle fait partie seront aussi supprimés.";
export const CONFIRM_TABLELINK_DELETE_TEXT = "Voulez-vous vraiment supprimer ce lien de tables ? Cette action est " +
    "irréversible et les réservations liées à cette table ne seront plus assignées à une table.";
export const CONFIRM_TABLE_ZONE_CHANGE = "Attention, vous devrez réassigner certaines réservations liées à cette table. Êtes-vous certain(e) de continuer ?";
export const YES_DELETE_TEXT = "Oui, supprimer";
export const CONTINUE_TEXT = "Oui, continuer";
export const NO_TEXT = "Non";
export const YES_TEXT = "Oui";
export const TABLE_NAME_TEXT = "Nom de la table";
export const SEATED_GUESTS_TEXT = "Personnes assises";
export const TERRACE_TABLE_TEXT = "Table en terrasse";
export const ROUND_TABLE_TEXT = "Table ronde";
export const HIGH_TABLE_TEXT = "Table haute";
export const ACTIVE_TABLE_TEXT = "Table active pour réservation";
export const NO_TABLES_YET_TEXT = "Vous n'avez pas encore ajouté de tables.";
export const NO_TABLELINKS_YET_TEXT = "Vous n'avez pas encore ajouté de lien de tables.";
export const HIGH_TEXT = "haute";
export const ROUND_TEXT = "ronde";
export const TERRACE_TEXT = "terrasse";
export const ADD_TABLE_TEXT = "Ajouter une table";
export const ADD_TABLELINK_TEXT = "Ajouter un lien de tables";
export const LINK_TABLES_TEXT = "Lier des tables";

export const DELETE_TEXT = "Supprimer";
export const SAVE_TEXT = "Enregistrer";

export const YOUR_RESTAURANT_TEXT = "votre restaurant";
export const THE_CUSTOMER_TEXT = "le client";

export const GO_BACK_LOGO = "arrow left";
export const GO_BACK_TEXT = "Retour";

export const CONFIRM_DELETE_TEXT = "Oui, supprimer";

// MARKETING
export const MARKETING_LIMIT_REACHED_TEXT = "Limite atteinte";
export const NO_MORE_EMAILS_THIS_MONTH_TEXT = "Vous ne pouvez plus envoyer autant d'e-mails ce mois-ci";
export const EMAIL_SUBJECT_TEXT = "Sujet de votre e-mail";
export const EMAIL_CONTENT_TEXT = "Contenu de votre e-mail";

// BOOKER
export const CALENDAR_TEXT = "Calendrier";

// CUSTOMERS
// UI
export const ADD_CUSTOMER_LOGO = "add user";
export const ADD_CUSTOMER_COLOR = "blue";
export const SEND_EMAIL_TO_CUSTOMER_LOGO = "mail";
export const SEND_EMAIL_TO_CUSTOMER_COLOR = "orange";
export const DOWNLOAD_CUSTOMERS_FILE_LOGO = "file-csv";
export const MANAGE_DUPLICATES_LOGO = "users";
export const DELETE_CUSTOMERS_LOGO = "user delete";

// TEXT
export const ADD_CUSTOMER_TEXT = "Ajouter";
export const SEND_EMAIL_TO_CUSTOMER_TEXT = "Envoyer un e-mail";
export const NO_CUSTOMER_TEXT = "Aucun client";
export const CONFIRM_CUSTOMER_DELETE_TEXT = "Voulez-vous vraiment supprimer ce client? Cette action est irréversible.";
export const DEFAULT_CUSTOMER_FIRSTNAME = "Client";
export const DEFAULT_CUSTOMER_LASTNAME = "de passage";
export const DEFAULT_CUSTOMER_FULLNAME = "Client de passage";
export const DOWNLOAD_CUSTOMERS_FILE_TEXT = "Exporter";
export const MANAGE_DUPLICATES_TEXT = "Gérer les doublons";
export const DELETE_CUSTOMERS_TEXT = 'Supprimer';
export const EDIT_CUSTOMERS_TEXT = "Éditer"



// RESERVATIONS
export const NO_RESERVATION_TEXT = "Aucune réservation";
export const ADD_RESERVATION_TEXT = "Ajouter une réservation";
export const ADULT_TEXT = "adulte";
export const ADULTS_TEXT = "adultes";
export const CHILD_TEXT = "enfant";
export const CHILDREN_TEXT = "enfants";

// MEAL TYPE
export const LEISURE_MEAL_TEXT = "Moment détente";
export const PROFESSIONAL_MEAL_TEXT = "Repas professionnel";
export const FAST_MEAL_TEXT = "Repas rapide";
export const BIRTHDAY_MEAL_TEXT = "Anniversaire";
export const SPECIAL_MEAL_TEXT = "Événement particulier";
export const OTHER_MEAL_TEXT = "Autre";

// HOURS
export const AT_TEXT = "à";
export const HOUR_SHORT_TEXT = "h";
export const MINUTE_TEXT = "minute";
export const MINUTES_TEXT = "minutes";
export const HOUR_TEXT = "heure";
export const HOURS_TEXT = "heures";

// DAYS
export const DAY_TEXT = "jour";
export const DAYS_TEXT = "jours";
export const MONDAY_TEXT = "lundi";
export const TUESDAY_TEXT = "mardi";
export const WEDNESDAY_TEXT = "mercredi";
export const THURSDAY_TEXT = "jeudi";
export const FRIDAY_TEXT = "vendredi";
export const SATURDAY_TEXT = "samedi";
export const SUNDAY_TEXT = "dimanche";
export const WEEKDAYS = [
    "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche",
]

// MONTHS
export const JANUARY_SHORT_TEXT = "janv.";
export const FEBRUARY_SHORT_TEXT = "févr.";
export const MARCH_SHORT_TEXT = "mars";
export const APRIL_SHORT_TEXT = "avr.";
export const MAY_SHORT_TEXT = "mai";
export const JUNE_SHORT_TEXT = "juin";
export const JULY_SHORT_TEXT = "juill.";
export const AUGUST_SHORT_TEXT = "août";
export const SEPTEMBER_SHORT_TEXT = "sept.";
export const OCTOBER_SHORT_TEXT = "oct.";
export const NOVEMBER_SHORT_TEXT = "nov.";
export const DECEMBER_SHORT_TEXT = "déc.";

export const JANUARY_TEXT = "janvier";
export const FEBRUARY_TEXT = "février";
export const MARCH_TEXT = "mars";
export const APRIL_TEXT = "avril";
export const MAY_TEXT = "mai";
export const JUNE_TEXT = "juin";
export const JULY_TEXT = "juillet";
export const AUGUST_TEXT = "août";
export const SEPTEMBER_TEXT = "septembre";
export const OCTOBER_TEXT = "octobre";
export const NOVEMBER_TEXT = "novembre";
export const DECEMBER_TEXT = "décembre";

export const MONTHS = [
    JANUARY_TEXT, 
    FEBRUARY_TEXT, 
    MARCH_TEXT, APRIL_TEXT, 
    MAY_TEXT, 
    JUNE_TEXT, 
    JULY_TEXT, 
    AUGUST_TEXT, 
    SEPTEMBER_TEXT, 
    OCTOBER_TEXT, 
    NOVEMBER_TEXT, 
    DECEMBER_TEXT,
]

export const MONTHS_OPTIONS = MONTHS.map((month, i) => ({ key: i, text: month, value: i + 1, }));

// SETTINGS
export const RESTAURANT_NAME_TEXT = "Nom du restaurant";
export const RESTAURANT_ADDRESS_TEXT = "Adresse du restaurant";

// TABLES
export const TABLE_TEXT = "Table";
export const TABLES_TEXT = "Tables";
export const TABLELINK_TEXT = "Lien de tables";

// ZONES
export const ZONE_TEXT = "Zone";
export const ZONES_TEXT = "Zones";

export const ZONE_NAME_TEXT = "Nom de la zone";
export const ZONE_ACTIVE_TEXT = "Active pour réservation";
export const ZONE_WIDTH_TEXT = "10";
export const ZONE_HEIGHT_TEXT = "10";
export const ZONE_AREA_TEXT = "Superficie de la zone (facultatif)";

export const ZONE_DEFAULT_TEXT = "Zone par défaut";

export const ZONE_DEFAULT_DELETE_TEXT = "Il est impossible de supprimer la zone par défaut."

export const CONFIRM_ZONE_DELETE_TEXT = "Voulez-vous vraiment supprimer cette zone? Cette action est " +
    "irréversible et les tables liées à cette zone seront assignées à la zone par défaut.";

export const CONFIRM_ZONE_REDIMENSION_TEXT = "Redimensionner une zone pourrait cacher certains objets si ils sont en dehors des nouvelles limites. Êtes-vous sûr de continuer ?";

// PREPOSITIONS
export const AND_TEXT = "et";

// TIME CONSTANTS
export const TIME_SLICE = 15; // in minutes
export const TIME_FORMAT = "HH:mm:ss";
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const DISPLAY_DATE_FORMAT = "DD-MM-YYYY";
export const DISPLAY_TIME_FORMAT = "HH:mm";
export const TIME_SYNC_INTERVAL = 1; // in minutes

export const DEFAULT_HIGHLIGHT_COUNTRIES = [ 'BE', 'FR', 'NL', 'DE', 'LU', 'IT', 'ES', 'GB', 'US', 'CH', 'IE'];


// WEBPACK FOOTER //
// ./src/constants/ui.js